query QueuesListQuery(
  $page: Int
  $rowsPerPage: Int
  $filter: QueuesFilterInput
) {
  queues(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      name
      jobCounts {
        waiting
        active
        completed
        failed
        delayed
      }
    }
  }
}
